import React from "react";
// import { Product } from "../types/restaurant";
import OrderItem from "./OrderItem";
import { OrderedProduct } from "src/shared/services/interfacev2";

interface OrderSummaryProps {
  selectedProducts: OrderedProduct[];
  editingNote: string | null;
  handleNoteChange: (orderId: string, note: string) => void;
  handleNoteClick: (productId: string) => void;
  handleNoteBlur: (orderId: string) => void;
  handleIncrement: (item: OrderedProduct) => void;
  handleDecrement: (item: OrderedProduct) => void;
  deleteProduct: (id: string) => void;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ selectedProducts, editingNote, handleNoteChange, handleNoteClick, handleNoteBlur, handleIncrement, handleDecrement, deleteProduct }) => {
  return (
    <div className="thin-scrollbar bg-gray-200 p-2 flex-grow overflow-y-auto">
      {selectedProducts.length > 0 ? (
        <ul className="space-y-2">
          {selectedProducts.map((order, idx) => (
            <OrderItem
              key={order.productId}
              order={order}
              editingNote={editingNote}
              handleNoteChange={handleNoteChange}
              handleNoteClick={handleNoteClick}
              handleNoteBlur={handleNoteBlur}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              deleteProduct={deleteProduct}
            />
          ))}
        </ul>
      ) : (
        <div className="h-full flex items-center justify-center text-gray-400 text-sm">No items added to order</div>
      )}
    </div>
  );
};

export default OrderSummary;
